import { Dispatch, SetStateAction } from 'react';

import { ListTable } from '@atom/mui';
import { AssetRequest, AssetRequestsFilters } from '@atom/types/assetRequest';

import RequestsTableHeader from './RequestsTableHeader';
import RequestsTableRow from './RequestsTableRow';

const { TableRow, TableBody, TableFooter, TablePagination } = ListTable;

type RequestsTableProps = {
  requests: AssetRequest[];
  totalCount: number;
  filters: AssetRequestsFilters;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  limit: number;
  setLimit: Dispatch<SetStateAction<number>>;
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
  isAscending: boolean;
  setIsAscending: Dispatch<SetStateAction<boolean>>;
  setActiveRequestId: (id: string) => void;
  offsetTop: string;
  /**
   * The portal shows an Asset column the asset page does not.
   */
  isPortalView?: boolean;
  /**
   * The asset whose Requests tab is rendering. Used to label a request as
   * Outgoing (from this asset) or Incoming.
   */
  assetId?: string;
};

const RequestsTable = ({
  requests,
  totalCount,
  filters,
  page,
  setPage,
  limit,
  setLimit,
  sortBy,
  setSortBy,
  isAscending,
  setIsAscending,
  setActiveRequestId,
  offsetTop,
  isPortalView = false,
  assetId,
}: RequestsTableProps) => (
  <ListTable offsetTop={offsetTop}>
    <RequestsTableHeader
      filters={filters}
      sortBy={sortBy}
      setSortBy={setSortBy}
      isAscending={isAscending}
      setIsAscending={setIsAscending}
      isPortalView={isPortalView}
    />
    <TableBody>
      {requests.map(request => (
        <RequestsTableRow
          key={request.id}
          request={request}
          filters={filters}
          setActiveRequestId={setActiveRequestId}
          isPortalView={isPortalView}
          assetId={assetId}
        />
      ))}
    </TableBody>
    <TableFooter>
      <TableRow>
        <TablePagination
          data-cy="requestsTablePagination"
          rowsPerPageOptions={[25, 50, 100, 250]}
          count={totalCount}
          rowsPerPage={limit}
          page={page}
          onPageChange={value => setPage(value)}
          onRowsPerPageChange={event => {
            setPage(1);
            setLimit(+event.target.value);
          }}
        />
      </TableRow>
    </TableFooter>
  </ListTable>
);

export default RequestsTable;
